import React__default from 'react';
import { DragAndDropProvider } from '../DragAndDropProvider/DragAndDropProvider.mjs';

const renderDragAndDropProvider = (children, features) => {
  return features !== null && features !== void 0 && features.usesSortableLibrary ? /*#__PURE__*/React__default.createElement(DragAndDropProvider, null, children) : children;
};
const OPTIONAL_PROVIDERS = [renderDragAndDropProvider];
function OptionalProviders({
  children,
  features
}) {
  return OPTIONAL_PROVIDERS.reduce((accumulatedChildren, optionalProvider) => optionalProvider(accumulatedChildren, features), children);
}

export { OptionalProviders };
